import { render, staticRenderFns } from "./DisplayPage.vue?vue&type=template&id=f41d97ec&"
import script from "./DisplayPage.vue?vue&type=script&lang=js&"
export * from "./DisplayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports